module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/issue-05-995d47978c163357aa947215901f07b9.png";